export const WORD_WHEEL_QUEST_TITLE = "Word Wheel Quest";
export const MAIN_PATH = "/prototype/mobile/word-wheel";
export const PLAY_PATH = "/prototype/mobile/word-wheel/play";
export const DAILY_PATH = "/prototype/mobile/word-wheel/daily";
export const DAILY_PLAY_PATH = "/prototype/mobile/word-wheel/daily/play";
export const SETTINGS_PATH = "/prototype/mobile/word-wheel/settings";
export const PLAY_MODE_JOURNEY = "journey";
export const PLAY_MODE_DAILY = "daily";

/** Montreal calendar day 1 for daily puzzle URLs (matches backend). */
export const WORD_WHEEL_DAILY_EPOCH = "2026-04-01";

/** Earliest date selectable in the daily calendar picker (same as day 1). */
export const WORD_WHEEL_DAILY_CALENDAR_MIN = WORD_WHEEL_DAILY_EPOCH;

export function dailyPlayPath(dateYmd) {
    if (!dateYmd) return DAILY_PLAY_PATH;
    return `${DAILY_PLAY_PATH}?date=${encodeURIComponent(dateYmd)}`;
}

/** App Store screenshot draft pages. */
export const SCREENSHOTS_MAIN_PATH = `${MAIN_PATH}/screenshots`;
export const SCREENSHOT_SCENE_PATH = `${MAIN_PATH}/screenshot/:slug`;

export function screenshotPath(slug) {
    return `${MAIN_PATH}/screenshot/${slug}`;
}

/** App Store / Play Store icon capture — 512×512 (bronze CROSS word wheel). */
export const APP_ICON_PATH = `${MAIN_PATH}/app-icon`;

/** Independent 512×512 copy for the next app-icon design iteration. */
export const APP_ICON_2_PATH = `${MAIN_PATH}/app-icon-2`;

/** 512×512 — company logo background with linked W-O-R-D overlay. */
export const APP_ICON_3_PATH = `${MAIN_PATH}/app-icon-3`;

/** Google Play Feature Graphic — 1024×500. */
export const FEATURE_GRAPHIC_PATH = `${MAIN_PATH}/feature-graphic`;

/** Dedicated 1920×1080 OBS capture play page (Android PlayScreen chrome). */
export const RECORDING_1080P_PATH = `${MAIN_PATH}/recording/1080p`;

/** 1920×1080 capture of the home hub: Classic, Hard Quest, and Master. */
export const RECORDING_1080P_PACKS_PATH = `${MAIN_PATH}/recording/1080p-packs`;

/** 1080p ending capture — feature graphic covers full 1920×1080. */
export const RECORDING_ENDING_PATH = `${MAIN_PATH}/recording/ending`;

